import React, { Component, PropsWithChildren } from 'react';

export default class DialogHeader extends Component<PropsWithChildren<any>> {
    public render() {
        return <div className="dialog-header">{this.props.children}</div>;
    }
}
